import { render, staticRenderFns } from "./zgy-videoList.vue?vue&type=template&id=573842c1&scoped=true&"
import script from "./zgy-videoList.vue?vue&type=script&lang=js&"
export * from "./zgy-videoList.vue?vue&type=script&lang=js&"
import style0 from "./zgy-videoList.vue?vue&type=style&index=0&id=573842c1&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "573842c1",
  null
  
)

export default component.exports